module.exports = __webpack_public_path__ + "img/milestone-hk.97988fb0.png";